import { loadLocale } from "@smart/itops-locale-dom";
import { Icon } from "@smart/itops-sb-design-system-dom";

export const NoWebEnquiries = () => {
  const { terms } = loadLocale();

  return (
    <div className="flex flex-col items-center justify-center gap-small">
      <Icon
        name="regularMagnifyingGlassMinus"
        className="text-neutral-500 w-[2.7rem] h-[2.7rem]"
      />
      <p className="text-neutral-500">{`No web ${terms.enquiry.name} links set up yet`}</p>
      <p className="text-neutral-500 text-caption">
        Create a link to share your intake form on your website, email
        signature, or ads.
      </p>
    </div>
  );
};
